<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('programs.create.title')"
        )

        // Login form
        program-template
</template>

<script>
    import Layout from '../../Layout/Layout';
    import ProgramTemplate from '../ProgramTemplate';
    import Title from '~components/Title';

    export default {
        components: {
            Layout,
            ProgramTemplate,
            TitleComponent: Title
        }
    };
</script>
